var initDate = new Date();
var currentYear = initDate.getFullYear();
var currentMonth = initDate.getMonth(); // 0, 1, 2 ...

var currentDay = initDate.getDate();
var nextTwoYear = new Date();
nextTwoYear.setFullYear(nextTwoYear.getFullYear() + 2);
nextTwoYear.setDate(nextTwoYear.getDate() - 1);
export var months = [
  "\u042F\u043D\u0432\u0430\u0440\u044C",
  "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
  "\u041C\u0430\u0440\u0442",
  "\u0410\u043F\u0440\u0435\u043B\u044C",
  "\u041C\u0430\u0439",
  "\u0418\u044E\u043D\u044C",
  "\u0418\u044E\u043B\u044C",
  "\u0410\u0432\u0433\u0443\u0441\u0442",
  "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
  "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
  "\u041D\u043E\u044F\u0431\u0440\u044C",
  "\u0414\u0435\u043A\u0430\u0431\u0440\u044C",
];
export var allYearEvents = {
  date_from: initDate,
  date_to: nextTwoYear,
  month: "\u0412\u0441\u0435",
};
export var monthsFull = months.map(function (month, i) {
  return {
    id: i,
    date_from: new Date(
      i >= currentMonth ? currentYear : currentYear + 1,
      i,
      i === currentMonth ? currentDay : 1
    ),
    // дата начала месяца
    date_to: new Date(i >= currentMonth ? currentYear : currentYear + 1, i + 1, 0, 23, 59, 59),
    // дата конца месяца
    title: month,
  };
});
export var dateFormation = function dateFormation(object, selector) {
  var monthNum = object.monthNum,
    year = object.year;
  var condition = monthNum >= currentMonth && year === currentYear;
  var actualYear = condition ? currentYear : currentYear + 1;

  if (selector === "from") {
    return new Date(
      actualYear,
      monthNum,
      monthNum === currentMonth && year === currentYear ? currentDay : 1
    );
  } else {
    return new Date(actualYear, monthNum + 1, 0, 23, 59, 59);
  }
};

var getCurrentMonth = function getCurrentMonth(months) {
  var index = new Date().getMonth();
  var first = months.slice(0, index - 1);
  var second = months.slice(index);
  return second.concat(first);
};

export var sortedMonths = getCurrentMonth(monthsFull);
